/* eslint-disable no-restricted-imports */
import { createPlugin } from '../../../Fct/createPlugin';
import { FctAnyType, FctString } from '../../../Fct/generics';
export var GetOffchainDataV2 = createPlugin({
    protocol: 'FUNCTIONS',
    type: 'GETTER',
    method: 'getOffchainDataV2',
    name: 'getOffchainDataV2',
    flowType: 'OFFCHAIN_ONLY',
    getParams: function () { return ({
        input: {
            endpoint: new FctString({ required: false, mode: 'INPUT' }),
            paramKey: new FctString({ required: false, mode: 'INPUT' }),
            paramValue: new FctAnyType({ required: false, mode: 'INPUT' }),
            methodParams: {},
        },
        output: {
            responseValue: new FctAnyType({ required: false, readonly: true }),
        },
    }); },
    // calculateValuesOnUserInput: ({ input, output }) => {
    //   const getResponse = async ({ service }: { service?: any }) => {
    //     if (!service) return { params: {}, error: 'service is not available' }
    //     if (!service.getData) return { params: {}, error: 'service to get off-chain data is not available' }
    //     const { endpoint, paramKey, paramValue } = input
    //     const getParamValue = (param: ParamsSchemas) => {
    //       if (param.isVariable) return param.estimatedValue
    //       return param.value
    //     }
    //     const response = await service.getData({
    //       endpoint: endpoint.value,
    //       query: [
    //         { key: getParamValue(paramKey), value: getParamValue(paramValue) },
    //       ],
    //     })
    //     if (!response.data) return { params: {}, error: 'request off-chain data error' }
    //     const data = response.data as { name?: string; value?: string }[]
    //     data.forEach((param, i) => {
    //       if (output.responseValue) {
    //         output.responseValue.label = param.name || ''
    //         output.responseValue.value = param.value || ''
    //       }
    //     })
    //     return {
    //       params: {},
    //       error: undefined,
    //     }
    //   }
    //   return {
    //     get: getResponse,
    //     depParamKeys: [
    //       'endpoint',
    //       'paramKey',
    //       'paramValue',
    //     ],
    //   }
    // },
});
